export default class ApiError extends Error {
    constructor(r, name, msg) {
        super(msg);
        this.name = name;
        this.r = r;
    }
}
